module.exports = {"513232100":"达扎寺镇","513232101":"唐克镇","513232102":"红星镇","513232103":"辖曼镇","513232104":"巴西镇","513232105":"阿西镇","513232106":"铁布镇","513232205":"麦溪乡","513232206":"嫩哇乡","513232210":"占哇乡","513232211":"降扎乡","513232214":"求吉乡","513232215":"包座乡","513232400":"白河牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513232.json
// module id = 2541
// module chunks = 0